// moms-harness:anchor v2
// JIRA: LOGISPRD-13852, LOGISPRD-13871
// MA18 [양식 다운로드] — 엑셀 업로드가 인식하는 헤더만 1행에 둔 빈 양식을 만든다.
import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'
import { UPLOAD_HEADER_MAP, UPLOAD_TEMPLATE_FILE_NAME } from './consts'

/** 필수 열 — 업로드 파서(`parseSkuAttributeExcel`)가 이 열이 없으면 파일 전체를 거부한다. */
const REQUIRED_HEADER = '바코드'

/**
 * 업로드 양식 워크북.
 *
 * ### 헤더를 [UPLOAD_HEADER_MAP] 에서 만든다 — 서버 다운로드 엑셀을 양식으로 쓰지 않는다
 *
 * 서버 다운로드(`SkuAttributeExcelDto`)는 헤더 네 개(`품목코드`·`품목명`·`품목옵션`·`브랜드`)가
 * 업로드 파서와 달라 **되올리면 그 열이 조용히 버려진다** (consts.ts `UPLOAD_HEADER_MAP` KDoc).
 * 업로드가 읽는 표에서 직접 만들면 양식과 파서가 어긋날 수 없다.
 *
 * SKU ID·화주코드 열은 없다 — SKU ID 는 SCM Hub 가 채번하고, 화주는 필터에서 고른 값을 쓴다.
 */
export const buildUploadTemplate = (): ExcelJS.Workbook => {
  const wb = new ExcelJS.Workbook()
  const ws = wb.addWorksheet('업로드양식')
  const headers = Object.keys(UPLOAD_HEADER_MAP)

  ws.columns = headers.map((header) => ({ header, key: header, width: Math.max(12, header.length * 2 + 4) }))

  const headerRow = ws.getRow(1)
  headerRow.font = { bold: true }
  const requiredIndex = headers.indexOf(REQUIRED_HEADER)
  if (requiredIndex >= 0) {
    const cell = headerRow.getCell(requiredIndex + 1)
    cell.font = { bold: true, color: { argb: 'FFD4380D' } }
    cell.note = '필수 — SKU 채번 키입니다. 비우면 그 행은 등록되지 않습니다.'
  }
  ws.views = [{ state: 'frozen', ySplit: 1 }]

  return wb
}

export const downloadUploadTemplate = async (): Promise<void> => {
  const buffer = await buildUploadTemplate().xlsx.writeBuffer()
  FileSaver.saveAs(
    new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `${UPLOAD_TEMPLATE_FILE_NAME}.xlsx`,
  )
}
